<template>
    <div class="menu-page flex flex-direction flex-shrink">
        <div class="header flex flex-direction justify-center align-center">
            <el-image class="avatar" v-if="user" :src="user.morglogo"></el-image>
            <img v-else class="avatar" :src="require('@/assets/img/defailt-avatar.png')"/>
            <div class="name margin-top-sm">{{ user.morgname }}</div>
        </div>
        <div class="menus  flex-sub  margin-top-xs">
            <div v-for="(item,index) in menus" :key="index" :class="{ active: navIndex[0]  === item.value}" class="menu-item flex flex-direction">
                <div class="menu-item_parent flex align-center justify-between" :class="[{expand:item.expand},{ active: navIndex[0]  === item.value}]">
                    <router-link :to="item.page" class="flex align-center">
                        <i :class="[item.icon]" class="iconfont"></i>
                        <div class="title margin-left-xs">{{ item.label }}</div>
                    </router-link>
                    <i v-if="item.child && item.child.length" :class="item.expand ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" class="menu-item_expand cursor"
                       @click="expandMenu(index,item.expand)"></i>
                </div>
                <div v-if="item.child && item.child.length && item.expand" class="menu-item_child flex flex-direction">
                    <router-link v-for="(child,child_index) in item.child" :key="child_index" :to="`${child.page}`" class="flex align-center justify-between">
                        <div :class="{ active: navIndex[1]  === child.value && navIndex[0] === item.value}" class="menu-item_child-title">
                            {{ child.label }}
                        </div>
                    </router-link>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import {getRoleMenus} from "@/utils/role";

export default {
    name: "MenuModular",
    data() {
        return {
            title: '绩效管理系统',
            menus: getRoleMenus(),
        };
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    props: {
        navIndex: {
            type: [Array],
            default: ()=>{
                return [0, 0]
            }
        }
    },
    created() {

    },
    methods: {
        expandMenu(index,expand){
            this.menus[index].expand = !expand
            this.$forceUpdate()
        }
    },
    watch: {
        navIndex(){
            let findIndex = this.menus.findIndex(f=>{ return this.navIndex[0] === f.value})
            if (findIndex !== -1) this.menus[findIndex].expand = true
        }
    },
};
</script>

<style lang="scss" scoped>
.menu-page {
    width: 274px;
    background: unset;


    .header {
        width: 100%;
        height: 173px;
        background-color: var(--blue);
        border-radius: 0 10px 10px 0;

        .avatar {
            width: 70px;
            height: 70px;
            border-radius: 70px;
        }

        .name {
            font-size: 16px;
            line-height: 20px;
            color: #ffffff;
        }
    }

    .menus {
        //height: calc(100vh - 301px);
        width: 100%;
        background-color: var(--blue);
        border-radius: 0 10px 0 0;
        &::-webkit-scrollbar{
            display: none;
        }

        .menu-item {
            width: 100%;
            background: none;
            &:not(:last-child){
                border-bottom: 1px solid #fff1;
            }


            &.active, &:hover {
                background-color: #041832;

                &:first-child {
                    border-radius: 0 10px 0 0;
                }

                .menu-item_parent {
                    .title, i {
                        color: var(--orange);
                    }
                }

            }

            .menu-item_parent {
                width: 100%;
                height: 90px;
                padding-left: 60px;
                padding-right: 24px;
                position: relative;

                &.active {
                    &:before {
                        position: absolute;
                        right: -7px;
                        border-top: 8px solid transparent;
                        border-left: 8px solid #041832;
                        border-bottom: 8px solid transparent;
                        top: 50%;
                        transform: translateY(-50%);
                        content: '';
                    }
                }
                &.expand{
                    border-bottom: 1px solid #fff1;
                }
                .title {
                    font-size: 18px;
                    font-weight: 600;
                    color: var(--white);
                }

                i {
                    font-size: 20px;
                    color: var(--white);

                }
            }

            .menu-item_child {
                padding: 10px 0px 15px 60px;
                user-select: none;
            }

            .menu-item_child-title {
                font-size: 16px;
                padding: 12px 32px;
                position: relative;
                color: #ffffff;

                &:before {
                    position: absolute;
                    content: '';
                    width: 2px;
                    height: 14px;
                    border-radius: 1px;
                    background: #ffffffff;
                    left: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                }

                &.active, &:hover {
                    color: var(--orange);
                    &:before {
                        background: var(--orange);
                    }
                }
            }
        }
    }
}
</style>
